module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/blue-slice-mobile.2f48a27.png";